import axios from 'axios'
import React, { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage1,
  TitlePage2,
  TitlePage3
} from '../../../Components/Main'
import ProfileDireita from '../../../Components/ProfileDireita'
import { NavDireita } from '../../../Components/SideBar-right/SideBarDireita'
import SidebarMobile from '../../../Components/SideBar-right/SidebarMobile'
import '../../../styles/pages/SubMenuPages/SubMenuFuncaoEPermissao/SubMenuFuncaoEPermissao.css'
import ModalFuncaoEPermissao from '../../MenuDireito/MenuDireito-Modal/ModalCadFuncaoEPermissao'
import ModalEditar from '../../MenuDireito/MenuDireito-Modal/ModalEdiFuncaoEPermissao'

function SubMenuFuncaoEPermissao() {
  var user = authService.getCurrentUser()
  const [funcoes, setFuncoes] = useState<any[]>([])
  const [modalOpen, setModalOpen] = useState(false)
  const [modalInfo, setModalInfo] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  function handleToggleComplete(objetos = []) {
    setModalInfo(objetos)
    setModalOpen(true)
  }
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/funcao/list/' +
          user[0].IdEmpresa
      )
      .then(response => {
        setFuncoes(response.data)
      })
  }, [])
  return (
    <div className="displayInteract">
      {modalOpen && (
        <ModalEditar setOpenModal={setModalOpen} modalInfo={modalInfo} />
      )}
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>

        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage1>CADASTRO DE FUNÇÕES</TitlePage1>
            {/* <TitlePage2>Cadastro De Função</TitlePage2> */}
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
            <ModalFuncaoEPermissao />
          </div>
        </div>

        <div className="tabelaPadrao">
          <table>
            <thead>
              {/* <th>CÓD</th> */}
              <th>Descrição Da Função</th>
              <th>Observação</th>
              <th>Ativo</th>
            </thead>
            <tbody>
              {funcoes
                .filter(val => {
                  if (searchTerm === '') {
                    return val
                  } else if (
                    val.fncDescricao
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(funcao => (
                  <tr
                    onClick={() => handleToggleComplete(funcao)}
                    key={funcao.IdFuncao}
                  >
                    {/* <td>
                    <p className="Space1">{funcao.IdFuncao}</p>
                  </td> */}
                    <td>
                      <p className="Space1">{funcao.fncDescricao}</p>
                    </td>
                    <td>
                      <p className="Space4">{funcao.fncObservacoes}</p>
                    </td>
                    <td>
                      <label className="container">
                        <input
                          type="checkbox"
                          defaultChecked={!!funcao.fncStatus}
                          disabled
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
      <nav className="esconderFiltro">
        <ProfileDireita />
        {/* <NavDireita /> */}
        {user[0].gruDescricao === 'Humanit' ? (
          <SidebarMobile />
        ) : user[0].gruDescricao === 'Administrativo' ? (
          <SidebarMobile />
        ) : (
          <div></div>
        )}
      </nav>
    </div>
  )
}

export default SubMenuFuncaoEPermissao
